import { FC, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { VendorData } from "../../Typings/dataListing";
import { getVendorsById } from "../../redux/actions/vendorsAction";
import { AppDispatch } from "../../redux/store";

const VendorsView: FC = () => {
  const { vendorid } = useParams<{ vendorid: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const [vendorData, setVendorData] = useState<VendorData | null>(null);
  const { permissions } = usePermissions();
  const roleid = localStorage.getItem("roleid") ?? "";

  useEffect(() => {
    getVendorData();
  }, [dispatch, vendorid]);

  const getVendorData = async () => {
    if (vendorid) {
      const payload = { vendorid: parseInt(vendorid, 10) };
      try {
        void dispatch(
          getVendorsById(payload, (response: any) => {
            if (response?.status !== 500) {
              setVendorData(response.data);
            }
          })
        );
      } catch (error) {
        console.error("Error fetching vendor details:", error);
      }
    }
  };

  const formatCurrency = (value: number | undefined) => {
    return value ? `$${value.toFixed(2)}` : "-";
  };

  const formatBoolean = (value: boolean | undefined) => {
    return value ? "Yes" : "No";
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">F2F Vendor</span>
              {vendorData?.market_name || "N/A"}
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Market Name
                <span className="d-block pt-1">
                  {vendorData?.market_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile Name
                <span className="d-block pt-1">
                  {vendorData?.profile_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile ID
                <span className="d-block pt-1">
                  {vendorData?.profile_id || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                City
                <span className="d-block pt-1">{vendorData?.city || "-"}</span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                State
                <span className="d-block pt-1">{vendorData?.state || "-"}</span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Application Fee
                <span className="d-block pt-1">
                  {formatCurrency(vendorData?.application_fee)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Membership Fee
                <span className="d-block pt-1">
                  {formatCurrency(vendorData?.membership_fee)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Weekly Fee
                <span className="d-block pt-1">
                  {formatCurrency(vendorData?.weekly_fee)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Percentage of Sales
                <span className="d-block pt-1">
                  {vendorData?.percentage_of_sales || "-"}%
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                No Charge to Vendors
                <span className="d-block pt-1">
                  {vendorData?.no_charge_to_vendors}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                State Tax Rate
                <span className="d-block pt-1">
                  {vendorData?.tax_rate_state || "-"}%
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                County Tax Rate
                <span className="d-block pt-1">
                  {vendorData?.tax_rate_county || "-"}%
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Municipality Tax Rate
                <span className="d-block pt-1">
                  {vendorData?.tax_rate_municipality || "-"}%
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Produce
                <span className="d-block pt-1">
                  Exempt: {formatBoolean(vendorData?.produce_exempt)}
                  <br />
                  Non-Exempt: {formatBoolean(vendorData?.produce_non_exempt)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Meat
                <span className="d-block pt-1">
                  Exempt: {formatBoolean(vendorData?.meat_exempt)}
                  <br />
                  Non-Exempt: {formatBoolean(vendorData?.meat_non_exempt)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Dairy
                <span className="d-block pt-1">
                  Exempt: {formatBoolean(vendorData?.dairy_exempt)}
                  <br />
                  Non-Exempt: {formatBoolean(vendorData?.dairy_non_exempt)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Eggs
                <span className="d-block pt-1">
                  Exempt: {formatBoolean(vendorData?.eggs_exempt)}
                  <br />
                  Non-Exempt: {formatBoolean(vendorData?.eggs_non_exempt)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Plants
                <span className="d-block pt-1">
                  Exempt: {formatBoolean(vendorData?.plants_exempt)}
                  <br />
                  Non-Exempt: {formatBoolean(vendorData?.plants_non_exempt)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Value Added
                <span className="d-block pt-1">
                  Exempt: {formatBoolean(vendorData?.value_added_exempt)}
                  <br />
                  Non-Exempt:{" "}
                  {formatBoolean(vendorData?.value_added_non_exempt)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Prepared Food
                <span className="d-block pt-1">
                  Exempt: {formatBoolean(vendorData?.prepared_food_exempt)}
                  <br />
                  Non-Exempt:{" "}
                  {formatBoolean(vendorData?.prepared_food_non_exempt)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Craft
                <span className="d-block pt-1">
                  Exempt: {formatBoolean(vendorData?.craft_exempt)}
                  <br />
                  Non-Exempt: {formatBoolean(vendorData?.craft_non_exempt)}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Vendor fee other text
                <span className="d-block pt-1">
                  {vendorData?.vendor_fee_other_text || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Average num vendors
                <span className="d-block pt-1">
                  {vendorData?.avg_num_vendors || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Products Exempt
                <span className="d-block pt-1">
                  {vendorData?.produce_exempt || "-"}
                </span>
              </li>
            </ul>

            <div className="pt-5 text-end">
              {permissions && roleid && (
                <NavLink to="/vendors">
                  <button type="button" className="formBtn cancel">
                    Back to List
                  </button>
                </NavLink>
              )}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default VendorsView;
